import { UseQueryOptions } from "@tanstack/react-query";

import { useNotifications } from "@/apiQueries/useNotifications";
import { ApiNotifications, AppError } from "@/types";

export const useNotificationsUnreadCount = (
  options?: Omit<UseQueryOptions<ApiNotifications, AppError>, "queryKey" | "queryFn">,
) => {
  const query = useNotifications(
    {
      status: "unread",
      page: "1",
      page_limit: "1",
    },
    options,
  );

  return {
    ...query,
    unreadCount: query.data?.pagination?.total || 0,
  };
};